const TipoCadasatro = {
  B2C: 1
}

export default TipoCadasatro
